import { defineStore } from 'pinia'
import complianceQuery from '../apollo/queries/pages/compliance.gql'

export const useComplianceStore = defineStore('compliance', {
  state: () => ({
    data: {}
  }),
  getters: {
    getCompliance: (state) => {
      return state.data.compliance ? state.data.compliance.data.attributes : null
    }
  },
  actions: {
    async requestData() {
      if (Object.keys(this.data).length !== 0) return

      const { data } = await useAsyncQuery(complianceQuery) // eslint-disable-line no-undef

      if (data) this.data = data
    }
  }
})
